import SaleInformationModal from './saleInformationModal'

export default SaleInformationModal
